
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@adc/ajax/-embroider-implicit-modules.js";
import "@adc/ember-utils/-embroider-implicit-modules.js";
import "@adc/i18n/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-lifeline/-embroider-implicit-modules.js";
import "@ember-data/adapter/-embroider-implicit-modules.js";
import "@ember-data/model/-embroider-implicit-modules.js";
import "@ember-data/serializer/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "@sentry/ember/-embroider-implicit-modules.js";
import "ember-inflector/-embroider-implicit-modules.js";
import "ember-data/-embroider-implicit-modules.js";
